// extracted by mini-css-extract-plugin
export default {"applyButton":"ApplyButton_applyButton__zdAHY","redApplyButton":"ApplyButton_redApplyButton__cWoKq"};